// 配置全局访问接口地址
let commonUrl;

if (process.env.NODE_ENV === 'development') {
    commonUrl = "https://xxkjgsfre.shop"; // 开发环境
} else {
    commonUrl = ""; // 生产环境
}

let baseUrl = {
    commonUrl
};

export default baseUrl;